function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { backgroundColor, borderColor, borderWidth, borderRadius, color, boxShadowFocus } from "../cssFor/cssFor";
import { rgba } from "../../styleUtils/styleUtils";
export var inputBase = function(theme) {
    return _objectSpread({
        borderStyle: 'solid'
    }, borderWidth('base', theme), backgroundColor('base', theme), borderColor('base', theme), color('base', theme), borderRadius('threeX', theme), {
        transitionProperty: 'box-shadow, border-color',
        transitionDuration: theme.animation.duration[100],
        transitionTimingFunction: theme.animation.productive.easeInOut.easing
    });
};
export var inputFocus = function(theme) {
    var hasShadow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    return _objectSpread({
        outline: 0
    }, borderColor('interactive.base', theme), hasShadow && boxShadowFocus('interactive', theme));
};
export var inputDisabled = function(theme) {
    return _objectSpread({}, borderColor('disabled', theme), color('disabled', theme));
};
export var inputActive = function(theme) {
    return _objectSpread({}, borderColor('active', theme));
};
export var inputError = function(theme) {
    return _objectSpread({
        outline: 0
    }, borderColor('danger.base', theme));
};
export var inputErrorFocus = function(theme) {
    var hasShadow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    return _objectSpread({}, borderColor('danger.base', theme), hasShadow && boxShadowFocus('danger', theme));
};
export var inputPlaceholder = function(theme) {
    return _objectSpread({}, color('soft', theme));
};
export var inputPlaceholderDisabled = function(theme) {
    return {
        color: rgba(theme.font.color.disabled, theme.depth.opacity.light)
    };
};
export var inputButtonDisabled = function(theme) {
    return _objectSpread({}, color('disabled', theme));
};
export var inputIconBase = function(theme) {
    return _objectSpread({}, color('soft', theme));
};
export var inputIconDisabled = function(theme) {
    return _objectSpread({}, color('disabled', theme));
};
export var getInputContainerStyles = function(param) {
    var container = param.container, variant = param.variant, hasError = param.hasError;
    var ref, ref1, ref2, ref3, ref4;
    return _objectSpread({}, !!variant && (container === null || container === void 0 ? void 0 : (ref = container.variant) === null || ref === void 0 ? void 0 : ref[variant]), {
        '&:focus-within > fieldset': _objectSpread({}, container === null || container === void 0 ? void 0 : (ref1 = container.focus) === null || ref1 === void 0 ? void 0 : ref1.base, !!variant && (container === null || container === void 0 ? void 0 : (ref2 = container.focus) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.variant) === null || ref3 === void 0 ? void 0 : ref3[variant]), hasError && (container === null || container === void 0 ? void 0 : (ref4 = container.focus) === null || ref4 === void 0 ? void 0 : ref4.hasError))
    });
};
export var inputContainerBase = function() {
    return {
        boxSizing: 'border-box',
        position: 'relative',
        width: '100%'
    };
};
export var inputContainerVariant = function() {
    return {
        grid: {
            height: '1.5rem'
        },
        underline: {
            height: '52px'
        },
        outline: {
            height: '42px',
            marginTop: '10px'
        },
        default: {}
    };
};
export var inputContainerFocus = function(theme) {
    return {
        base: {
            borderColor: theme.borderColor.interactive.base,
            borderWidth: "".concat(theme.size.border.focus, "px"),
            borderStyle: 'solid',
            transitionProperty: 'border-color',
            transitionDuration: theme.animation.duration[100],
            transitionTimingFunction: theme.animation.productive.easeInOut.easing
        },
        variant: {
            default: _objectSpread({
                borderWidth: "".concat(theme.size.border.base, "px")
            }, inputFocus(theme)),
            underline: {
                borderWidth: "0 0 ".concat(theme.size.border.focus, "px 0")
            },
            grid: {
                borderWidth: "0 0 ".concat(theme.size.border.focus, "px 0")
            },
            outline: {}
        },
        hasError: _objectSpread({}, inputErrorFocus(theme, false))
    };
};
